module.exports = __webpack_public_path__ + "components/home-header/static/header-1--large-562a864acabf9aeb80119789fcd25be7.jpg";